<template>
  <Layout>
    <template #content>
      <div class="mainContent">
        <pageHead device="desktop" page="chess" :title="Title" :description="$t('store.chess_description')"/>

        <template v-if="DEF_webStyle == 'sgph'">
          <gameMenu :categoryId="CategoryId"/>
          <eGame :categoryId="CategoryId" :title="Title"/>
        </template>

        <template v-else>
          <div class="game-wrap pcchess">
            <h1 class="title"><span class="bg">{{ Title }}</span><q class="dn fg">{{ Title }}</q></h1>
            <div class="game-list one-piece chess">
              <template v-for="(item, index) in Product(CategoryId)">
                <gameMod
                  v-model="item.Id"
                  :className="`game-group product_${item.Id} ${item.Maintain}`"
                  :productId="CategoryId"
                  :data-text="$t('store.uphold_ing')"
                />
              </template>
            </div>
          </div>  
        </template>

      </div>
    </template> 
  </Layout>
</template>
<script>
  const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
  import pageHead from "~/components/common/pageHead.vue";
  import gameMod from "~/components/desktop/gameMod.vue";
  import gameMenu from "~/components/desktop/gameMenu.vue";
  import eGame from "~/pages/game/egame/egame.vue";  
  export default {
    components: {
      Layout,
      pageHead,
      gameMenu,
      eGame,
      gameMod
    },
    data() {
      return {
        CategoryId: 5
      };
    },
    computed: {
      DEF_webStyle() {
        return process.env.DEF_webStyle || 'default';
      },
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        if (this.HasX)
          return '棋牌遊戲' + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
        else
          return this.$t("store.game_chess") + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
      },
      ...mapState(['WebSetting']),
      ...mapState("game", ["ProductId"]),
      ...mapGetters(["Product", "WebSeoName", "ShowPageWebSeoName"]),
    },
  };
</script>

<style scoped></style>
